<template>
  <div style="width: 52px;" class="text-xs-center">
    <v-menu
      bottom
      left
      v-model="menu"
      v-scroll="onScroll"
    >
      <wz-avatar :src="userAvatar + '?' + Math.random()" :username="fullName" size="32px" slot="activator"></wz-avatar>
      <v-list two-line>
        <v-list-tile to="/profile">
          <v-list-tile-action>
            <wz-avatar :src="userAvatar + '?' + Math.random()" :username="fullName" size="48px"></wz-avatar>
          </v-list-tile-action>
          <v-list-tile-content> 
            <v-list-tile-title>{{ fullName }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ account.type }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list dense class="card">
        <v-list-tile to="/account" v-if="checkPermission('NO_AGENTS')">
          <v-list-tile-action ><v-icon>business_center</v-icon></v-list-tile-action>
          <v-list-tile-title >{{ $t('gestionAccount') | cap }}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile :href="checkUrlSupport" target="_blank">
          <v-list-tile-action><v-icon>launch</v-icon></v-list-tile-action>
          <v-list-tile-title>{{ $t('support') | cap }}</v-list-tile-title>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile @click="dialog = true">
          <v-list-tile-action><v-icon>power_settings_new</v-icon></v-list-tile-action>
          <v-list-tile-title>{{ $t('logout') | cap }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('logout') | cap }} ?</v-card-title>
        <v-card-text>
          {{ $t('textDeconnexion') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="isLogout" flat="flat" @click.native="dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn
            :disabled="isLogout"
            :loading="isLogout"
            color="primary"
            @click.native="logout()"
          >{{ $t('logout') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      menu: false,
      dialog: false,
      isLogout: false,
      supportAdress: 'https://support.targetfirst.com/'
    }
  },
  methods: {
    logout () {
      // if (this.$store.state._StoreWatcheeBox.sessionsPrivees.length) {
        // parse le tableau pour trouve le visiteur et la place occupé
      // this.$store.commit('_StoreWatcheeBox/REMOVE_ALL_CHATS_SESSION') // vuex mutation
      // this.$store.commit('_StoreWatcheeBox/REMOVE_ALL_CHATS_SESSION', { socket: this.$socket }) // vuex mutation
      console.log('[WzAgentMenu] logout ')
      this.$store.dispatch('_StoreWatcheeBox/removeAllChatsSession', this.$socket) // vuex action
      // }

      // vide le localstorage du login et password pour la reconnexion automatique
      localStorage.removeItem('tf-login')
      localStorage.removeItem('tf-password')
      // on deconnect du BO
      this.isLogout = true
      // this.axios.post('post/logout.php')
      // .then(response => {
      //   this.$store.dispatch('logout', this.$socket)
      // })
      // .catch()
      // .then(() => {
      //   this.isLogout = false
      //   this.dialog = false
      // })
    },
    onScroll (e) {
      this.menu = false
    }
  },
  computed: {
    ...mapGetters('_User', ['fullName', 'userAvatar', 'account']),
    checkUrlSupport () {
      return 'https://support.targetfirst.com/'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzAgentMenu.vue